export default __webpack_public_path__ + "static/media/dyeing5.369750cf.png";